module.exports = __webpack_public_path__ + "media/old_images/default-image-generic-39c512c1.png";